import React from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import bgMain from "../images/bg-main.png";
import cardBg from "../images/smart_yield_move/smart_yield_move.png";
import { ThemeLightState } from "./ThemeLightState";

const SmartYieldMoveDetail = () => {
  const navigate = useNavigate();
  function handleBackToForm() {
    navigate("/");
  }
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Background elements */}
      <div className="fixed inset-0 overflow-hidden">
        <div
          className="absolute w-full h-full overflow-hidden"
          style={{
            backgroundImage: `url(${bgMain})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.8,
          }}
        ></div>
      </div>

      {/* Main content */}
      <div className="relative z-10 w-full max-w-md mx-auto pt-8 px-4 pb-20">
        {/* Header */}
        <div className="flex items-center justify-between mb-6 relative">
          <button
            onClick={handleBackToForm}
            className="text-[#1c1f25] hover:text-[#f784ff] transition-colors z-10"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <h2 className="text-[#1c1f25] text-xl font-medium absolute left-0 right-0 text-center">
            Smart Yield Move
          </h2>
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            key="main-card"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.4 }}
            className="mt-6 w-[345px] mx-auto"
          >
            {/* Memecoin Tag Card - Based on Figma design */}
            <div className="flex flex-col w-[345px] items-start gap-[15px] p-[15px] relative bg-[rgba(255,255,255,0.75)] rounded-[16px] overflow-hidden shadow-lg mx-auto">
              <div className="flex flex-col items-center gap-2.5 relative self-stretch w-full flex-[0_0_auto]">
                {/* Card Header with background image */}
                <img
                  className="relative self-stretch w-full h-[255px] object-cover"
                  src={cardBg}
                  alt="Card Background"
                />

                {/* Title */}
                <p className="relative w-fit font-medium text-[#1c1f25] text-xl tracking-[0] leading-[35px] whitespace-nowrap">
                  Smart Yield Move
                </p>

                {/* Subtitle */}
                <p className="relative self-stretch font-normal text-[#676C77] text-base tracking-[0] leading-[23px]">
                  Stake idle assets! If your account holds a large amount of
                  idle stablecoins, BTC, ETH, or BNB and there's little trading
                  activity, we’ll suggest moving them to corresponding Earn or
                  on-chain products to generate yield.
                </p>

                {/* Coming Button */}
                <div className="mt-4 w-full">
                  <ThemeLightState
                    className="self-stretch h-10 w-full"
                    divClassName="mt-[-4.50px] text-base mb-[-2.50px] whitespace-nowrap font-medium"
                    text="Coming"
                  />
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default SmartYieldMoveDetail;
